import { render, staticRenderFns } from "./workHistory.vue?vue&type=template&id=39b1aa44&scoped=true"
import script from "./workHistory.vue?vue&type=script&lang=js"
export * from "./workHistory.vue?vue&type=script&lang=js"
import style0 from "./workHistory.vue?vue&type=style&index=0&id=39b1aa44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1aa44",
  null
  
)

export default component.exports